<div class="asset-selection-dialog">
  <div class="asset-name">
    <span>{{ uploadedFile }}</span>
  </div>
  <div class="dialog-message">
    The uploaded document above is already available in Veeva, would you like to
    select an existing document from the below list?
  </div>

  <div class="asset-list-scroll" *ngIf="assets?.length > 0">
    <mat-radio-group [(ngModel)]="selectedAssetId" class="asset-radio-group">
      <mat-radio-button
        *ngFor="let asset of assets"
        [value]="asset.id"
        class="asset-radio"
      >
        <span class="listStyle">
          <a
            [href]="
              'https://' + urlDomain + '/ui/#doc_info' + asset.asset_url_link
            "
            target="_blank"
          >
            {{ asset.asset_name }}
            <span *ngIf="asset.subtype__v" class="subtype-text">
              - {{ asset.subtype__v }}</span
            >
          </a>
        </span>
        <!-- {{ asset.asset_name }} -->
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="dialog-actions">
    <div class="button-class">
      <button mat-stroked-button class="btn-text-cancel" (click)="onCancel()">
        Cancel
      </button>
      &nbsp;
      <button
        mat-stroked-button
        class="btn-text-proceed"
        (click)="onConfirm()"
        [disabled]="!selectedAssetId"
      >
        Confirm
      </button>
    </div>

    <!-- <button mat-stroked-button (click)="onCancel()">Cancel</button>
    <button
      mat-stroked-button
      color="primary"
      (click)="onConfirm()"
      [disabled]="!selectedAssetId"
    >
      Confirm
    </button> -->
  </div>
</div>
